import React, { useEffect, useRef, useState } from "react";
import TextInput from "../../../../common/TextInput";
import TeamMultipleDropdown from "../../../../common/TeamMultipleDropdown";
import AccordionComponent from "../../../../common/Accordion";
import SearchableSingleSelectDropdown from "../../../../common/SearchableDropdown";
import { validateTeamForm } from "./TeamValidation";
import Snackbar from "../../../../common/Snackbar";
import {
  addStakeholderMembers,
  addTeamHeaders,
  addTeamMembers,
  deleteStakeholders,
  deleteTeamMembers,
  getEmployeeNameforTeam,
  getHODName,
  getRestrictedStakeHolderforTeam,
  getStakeHolderDetails,
  getStakeHolderforTeam,
  getTeamHeaderDetails,
  getTeamMemberDetails,
  updateTeamHeaders,
} from "../action/fetchTeamsData";
import MultilineTextBox from "../../../../common/MultilineTextBox";
import Loader from "../../../../common/Loader";
import { Col, Row } from "react-bootstrap";
import FormattedPhoneInput from "../../../../common/FormattedPhoneInput";

interface EmployeeData {
  userid: number;
  userfullname: string;
  userTypeName: string;
}
interface StakeHolderData {
  stakeholderId: number;
  entityName: string;
  stakeholderTypeName: string;
}

interface GroupedOption {
  group: string;
  options: { label: string; value: number }[];
}

interface AddNewTeamProps {
  userData: any;
  action: string;
  onCancel: () => void;
  userID: any;
  onTeamSaved: (teamId: number, savedTeamName: string) => void;
}

const AddUpdateTeam: React.FC<AddNewTeamProps> = ({
  userData,
  action,
  onCancel,
  userID,
  onTeamSaved,
}) => {
  const isEditable = action !== "View";
  const [loading, setLoading] = useState(false);
  const [teamId, setTeamId] = useState<number | null>(null); // Track ID availability
  const [teamName, setTeamName] = useState("");
  const [accordianTeamName, setAccordianTeamName] = useState("");
  const [phoneNumber, setTeamPhone] = useState("");
  const [faxNumber, setTeamFax] = useState("");
  const [emailAddress, setTeamEmail] = useState("");
  const [description, setDescription] = useState("");
  const [hodOption, setHODOption] = useState<any[]>([]);
  const [teamHodId, setTeamHOD] = useState<string | number | null>(null);
  const [hodID, setHodId] = useState<string | number | null>(null);
  const [selectedEmployee, setSelectedEmployee] = useState<(string | number)[]>(
    [],
  ); // Selected names from first dropdown
  const [addedEmployee, setAddedEmployee] = useState<(string | number)[]>([]); // Added names to the first table
  const [employeeOption, setEmployeeOption] = useState<GroupedOption[]>([]);

  const [selectedStakeholders, setSelectedStakeholders] = useState<
    (string | number)[]
  >([]); // Selected names from second dropdown1
  const [addedStakeholders, setAddedStakeholders] = useState<
    (string | number)[]
  >([]); // Added names to the second table
  const [stakeHolderOption, setStakeHolderOption] = useState<GroupedOption[]>(
    [],
  );
  const [stakeholderDetails, setStakeholderDetails] = useState<any[]>([]);
  const [isActive, setIsActive] = useState(true);
  const [activeKey, setActiveKey] = useState<string | null>("0");

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");
  const [dynamicGroupColors, setDynamicGroupColors] = React.useState<{
    [key: string]: string;
  }>({});

  const [initialHeaderData, setInitialHeaderData] = useState({
    teamName: "",
    phoneNumber: "",
    faxNumber: "",
    emailAddress: "",
    description: "",
    teamHodId: null as string | number | null,
    isActive: true,
  });

  const [initialIsActive, setInitialIsActive] = useState(true);

  const handleAdd = async () => {
    // Only add employees that are not already in the addedEmployee list
    const newEmployees = selectedEmployee.filter(
      (employee) => !addedEmployee.includes(employee),
    );

    if (newEmployees.length === 0) {
      setSnackbarMessage("Team member has been already added.");
      setError("error"); // Change this to "error" for a more appropriate message type
      setSnackbarOpen(true);
      return;
    }

    // Prepare the team ID and payload
    const teamIdToUse = userData?.teamId || teamId;
    const payload = {
      teamId: teamIdToUse,
      teamMemberUserId: newEmployees.join(","), // Convert array to comma-separated string
    };
    setAddedEmployee((prev) => [...prev, ...newEmployees]);
    try {
      // Call the API to save team members
      const response = await addTeamMembers(payload);

      if (response && response.isSuccess) {
        setSnackbarMessage("Team Members Added Successfully");

        setError("success");
        setSnackbarOpen(true);

        // Update the state only after a successful API call
      }
    } catch (error) {
      console.error("Error while adding team members:", error);
    }
  };

  const handleRemove = async (option: string | number) => {
    // Prepare the payload
    const teamIdToUse = userData?.teamId || teamId; // Use the appropriate team ID
    const payload = {
      teamId: teamIdToUse,
      teamMemberUserId: option.toString(), // Send the removed employee ID
    };

    // If the API call is successful, update the state to remove the employee
    setAddedEmployee((prev) => prev.filter((item) => item !== option));
    setSelectedEmployee((prev) => prev.filter((item) => item !== option));
    try {
      // Call the API
      const response = await deleteTeamMembers(payload);

      if (response && response.isSuccess) {
        setSnackbarMessage("Team member has been removed.");
        setError("success");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error removing team member:", error);
      // Optionally, handle the error (e.g., show an error message)
    }
  };

  const handleAdd2 = async () => {
    const newStakeholders = selectedStakeholders.filter(
      (employee) => !addedStakeholders.includes(employee),
    );

    if (newStakeholders.length === 0) {
      setSnackbarMessage("Clients have already been added.");
      setError("error");
      setSnackbarOpen(true);
      return;
    }

    const teamIdToUse = userData?.teamId || teamId;

    const payload = {
      teamId: teamIdToUse,
      stakeholderId: newStakeholders.join(","),
      comments: "string",
    };

    setAddedStakeholders((prev) => [...prev, ...newStakeholders]);

    try {
      const response = await addStakeholderMembers(payload);

      if (response && response.isSuccess) {
        setSnackbarMessage("Clients added successfully");
        setError("success");
        setSnackbarOpen(true);

        const updatedStakeholders = await getStakeHolderDetails(teamIdToUse);
        setStakeholderDetails(updatedStakeholders);

        await fetchDropDownData();
      }
    } catch (error) {
      console.error("Error while adding StakeHolders members:", error);
    }
  };

  const handleRemove2 = async (option: string | number) => {
    const teamIdToUse = userData?.teamId || teamId;

    const payload = {
      teamId: teamIdToUse,
      stakeholderId: option.toString(),
      comments: "string",
    };

    setAddedStakeholders((prev) => prev.filter((item) => item !== option));
    setSelectedStakeholders((prev) => prev.filter((item) => item !== option));

    try {
      const response = await deleteStakeholders(payload);

      if (response && response.isSuccess) {
        setSnackbarMessage("Clients have been removed.");
        setError("success");
        setSnackbarOpen(true);

        const updatedStakeholders = await getStakeHolderDetails(teamIdToUse);
        setStakeholderDetails(updatedStakeholders);

        await fetchDropDownData();
      }
    } catch (error) {
      console.log("Error removing team member:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const headerData = await getTeamHeaderDetails(userData.teamId);

        const teamInfo =
          Array.isArray(headerData) && headerData.length > 0
            ? headerData[0]
            : null;

        if (teamInfo) {
          if (teamInfo.teamName) setTeamName(teamInfo.teamName);
          else setTeamName("");
          if (teamInfo.teamName) setAccordianTeamName(teamInfo.teamName);
          else setAccordianTeamName("");
          if (teamInfo.phonenumber) setTeamPhone(teamInfo.phonenumber);
          else setTeamPhone("");
          if (teamInfo.faxNumber) setTeamFax(teamInfo.faxNumber);
          else setTeamFax("");
          if (teamInfo.emailAddress) setTeamEmail(teamInfo.emailAddress);
          else setTeamEmail("");
          if (teamInfo.description) setDescription(teamInfo.description);
          else setDescription("");
          if (teamInfo.teamHodId) setTeamHOD(teamInfo.teamHodId);
          else setTeamHOD("");
          if (teamInfo.teamHodId) setHodId(teamInfo.teamHodId);
          else setHodId("");

          if (userData) {
            const isActiveState = userData?.isActive === 1;
            setIsActive(isActiveState);
            setInitialIsActive(isActiveState);
          } else {
            setIsActive(true);
            setInitialIsActive(true);
          }

          setInitialHeaderData({
            teamName: teamInfo.teamName || "",
            phoneNumber: teamInfo.phonenumber || "",
            faxNumber: teamInfo.faxNumber || "",
            emailAddress: teamInfo.emailAddress || "",
            description: teamInfo.description || "",
            teamHodId: teamInfo.teamHodId || null,
            isActive: userData?.isActive === 1,
          });
        }

        const teamMemberData = await getTeamMemberDetails(userData.teamId);

        const teamMemberIds = teamMemberData.map(
          (item: any) => item.teamMemberUserId,
        );
        setAddedEmployee(teamMemberIds);
        setSelectedEmployee(teamMemberIds);

        const stakeholderData = await getStakeHolderDetails(userData.teamId);

        const stakeholderIds = stakeholderData.map(
          (item: any) => item.stakeholderId,
        );
        setAddedStakeholders(stakeholderIds);
        setSelectedStakeholders(stakeholderIds); // Set pre-selected dropdown values
        setStakeholderDetails(stakeholderData);
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
      }
    };

    fetchData();
  }, [userData]);

  const fetchDropDownData = async () => {
    try {
      const hodData = await getHODName();
      const transformedOptionsHOD = hodData.map((item: any) => ({
        value: item.userid, // Use userid as the value
        label: item.userfullname, // Use userfullname as the label
      }));
      setHODOption(transformedOptionsHOD || []);
      setHodId(teamHodId);

      const employeeData: EmployeeData[] = await getEmployeeNameforTeam();

      // Transform data to grouped structure
      const groupedData = employeeData.reduce<Record<string, GroupedOption>>(
        (acc, curr) => {
          // if (curr.userid === hodID) return acc; // Exclude teamHodId

          const group = curr.userTypeName; // Use `userTypeName` as the group
          if (!acc[group]) {
            acc[group] = {
              group, // Group name
              options: [], // Initialize options
            };
          }
          acc[group].options.push({
            label: curr.userfullname, // Use `userfullname` for the label
            value: curr.userid, // Use `userid` for the value
          });

          return acc;
        },
        {},
      );

      // Convert grouped object to array
      const transformedOptions = Object.values(groupedData);

      setEmployeeOption(transformedOptions);

      const stakeholderData: StakeHolderData[] =
        await getRestrictedStakeHolderforTeam();

      // Transform data to grouped structure
      const stakeholderDatagroupedData = stakeholderData.reduce<
        Record<string, GroupedOption>
      >((acc, curr) => {
        const group = curr.stakeholderTypeName; // Use `userTypeName` as the group
        if (!acc[group]) {
          acc[group] = {
            group, // Group name
            options: [], // Initialize options
          };
        }
        acc[group].options.push({
          label: curr.entityName, // Use `userfullname` for the label
          value: curr.stakeholderId, // Use `userid` for the value
        });
        return acc;
      }, {});

      // Convert grouped object to array
      const stakeholdertransformedOptions = Object.values(
        stakeholderDatagroupedData,
      );

      setStakeHolderOption(stakeholdertransformedOptions);
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  };

  useEffect(() => {
    fetchDropDownData();
  }, []);

  useEffect(() => {
    fetchDropDownData();
  }, [hodID]);

  React.useEffect(() => {
    // Generate colors for each group dynamically
    const colors = [
      "#5c9cf9", // Blue
      "#f39c12", // Yellow
      "#2ecc71", // Green
      "#e74c3c", // Red
      "#9b59b6", // Purple
      "#1abc9c", // Teal
      "#34495e", // Dark Gray
    ];

    const generatedColors: { [key: string]: string } = {};
    let colorIndex = 0;

    employeeOption.forEach((group) => {
      if (!generatedColors[group.group]) {
        generatedColors[group.group] = colors[colorIndex % colors.length];
        colorIndex++;
      }
    });

    stakeHolderOption.forEach((group) => {
      if (!generatedColors[group.group]) {
        generatedColors[group.group] = colors[colorIndex % colors.length];
        colorIndex++;
      }
    });

    setDynamicGroupColors(generatedColors);
  }, [employeeOption, stakeHolderOption]);

  const validateForm = () => {
    const validationErrors = validateTeamForm(
      teamName,
      description,
      teamHodId,
      emailAddress,
      phoneNumber,
      faxNumber,
    );

    if (validationErrors.length > 0) {
      setSnackbarMessage(validationErrors.join("\n")); // Show error messages directly
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true; // No need to reset the snackbar message here
  };

  const updateInitialStates = () => {
    setInitialHeaderData({
      teamName,
      phoneNumber,
      faxNumber,
      emailAddress,
      description,
      teamHodId,
      isActive,
    });
    setInitialIsActive(isActive);
  };

  const hasChanges = () => {
    return (
      teamName !== initialHeaderData.teamName ||
      phoneNumber !== initialHeaderData.phoneNumber ||
      faxNumber !== initialHeaderData.faxNumber ||
      emailAddress !== initialHeaderData.emailAddress ||
      description !== initialHeaderData.description ||
      teamHodId !== initialHeaderData.teamHodId ||
      isActive !== initialHeaderData.isActive // ✅ Added this line
    );
  };

  const handleSave = async () => {
    if (validateForm()) {
      setLoading(true); // Start loader

      try {
        const teamData = {
          teamName,
          phoneNumber,
          faxNumber,
          emailAddress,
          description,
          teamHodId,
          isActive: isActive ? 1 : 0,
          ...(teamId || userData?.teamId
            ? { teamId: teamId || userData.teamId }
            : {}),
        };

        let saveHeader;
        if (teamId || userData?.teamId) {
          saveHeader = await updateTeamHeaders(teamData);
        } else {
          saveHeader = await addTeamHeaders(teamData);
        }

        if (saveHeader && saveHeader.result) {
          if (!teamId) {
            setTeamId(saveHeader.result);
            onTeamSaved(saveHeader.result, teamName);
          }
          setSnackbarMessage(
            teamId || userData?.teamId
              ? "Team has been updated successfully"
              : "Team has been added successfully",
          );

          setAccordianTeamName(teamName);
          fetchDropDownData();
          setError("success");
          setSnackbarOpen(true);
          setActiveKey(null);
          updateInitialStates();

          // if (teamHodId !== null && addedEmployee.includes(teamHodId)) {
          //   const teamIdToUse = userData?.teamId || teamId;
          //   const payload = {
          //     teamId: teamIdToUse,
          //     teamMemberUserId: teamHodId.toString(), // Convert ID to string
          //   };

          //   setAddedEmployee((prev) =>
          //     prev.filter((item) => item !== teamHodId),
          //   );
          //   setSelectedEmployee((prev) =>
          //     prev.filter((item) => item !== teamHodId),
          //   );

          //   try {
          //     await deleteTeamMembers(payload);
          //   } catch (error) {
          //     console.error("Error removing team member:", error);
          //   }
          // }
          if (teamHodId !== null) {
            const teamIdToUse = saveHeader.result || userData?.teamId || teamId;

            // Check if HOD is already added
            if (!addedEmployee.includes(teamHodId)) {
              const payload = {
                teamId: teamIdToUse,
                teamMemberUserId: teamHodId.toString(),
              };

              try {
                const response = await addTeamMembers(payload);

                if (response?.isSuccess) {
                  setAddedEmployee((prev) => [...prev, teamHodId]);
                }
              } catch (error) {
                console.error("Error adding HOD as team member:", error);
              }
            }
          }
        } else {
          setSnackbarMessage(saveHeader.message);
          setError("error");
          setSnackbarOpen(true);
        }
      } catch (error) {
        console.error("Error saving team:", error);
        setSnackbarMessage("An error occurred while saving the team.");
        setError("error");
        setSnackbarOpen(true);
      } finally {
        setLoading(false); // Stop loader regardless of success or failure
      }
    }
  };

  const handleReset = () => {
    if (initialHeaderData) {
      setTeamName(initialHeaderData.teamName);
      setTeamPhone(initialHeaderData.phoneNumber);
      setTeamFax(initialHeaderData.faxNumber);
      setTeamEmail(initialHeaderData.emailAddress);
      setDescription(initialHeaderData.description);
      setTeamHOD(initialHeaderData.teamHodId);
      setIsActive(initialIsActive);
    } else {
      // Clear all states if no initial data
      setTeamName("");
      setTeamPhone("");
      setTeamFax("");
      setTeamEmail("");
      setDescription("");
      setTeamHOD(null);
    }
  };
  const handleCancel = () => {
    setAddedEmployee([]);
    setSelectedEmployee([]);
    setSelectedStakeholders([]);
    setAddedStakeholders([]); // Clear the addedEmployee state by setting it to an empty array
    onCancel();
  };

  const lastOpenedRef = useRef<number | null>(null);

  useEffect(() => {
    if (!accordianTeamName) return;

    const handleScroll = () => {
      // Ignore scrolls if accordion was just opened in last 300ms
      if (lastOpenedRef.current && Date.now() - lastOpenedRef.current < 300) {
        return;
      }

      const formBottom = document
        .getElementById("team-form-buttons")
        ?.getBoundingClientRect().bottom;
      const distanceFromBottom = window.innerHeight - (formBottom ?? 0);

      if (activeKey !== null && distanceFromBottom > 100) {
        setActiveKey(null);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [activeKey, accordianTeamName]);

  const renderAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
        title:
          activeKey === index.toString() ? (
            item.title
          ) : (
            <>
              {item.title} -{" "}
              <span className="fw-normal">{accordianTeamName || ""}</span>
            </>
          ),
      }))}
      activeKey={activeKey}
      onSelect={(key) => {
        lastOpenedRef.current = Date.now(); // Set open time
        setActiveKey(key as string);
      }}
    />
  );

  const [teammemberKey, setteammemberKey] = useState<string | null>("0");

  const teammemberAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={teammemberKey}
      onSelect={(key) => setteammemberKey(key as string)}
    />
  );

  const [associatedqmeKey, setassociatedqmeKey] = useState<string | null>("0");

  const associatedqmeAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={associatedqmeKey}
      onSelect={(key) => setassociatedqmeKey(key as string)}
    />
  );

  return (
    <>
      <div className="main_wrapper_section">
        {/* <Loader isLoading={loading} /> */}
        <Snackbar
          message={snackbarMessage}
          open={snackbarOpen}
          onClose={() => setSnackbarOpen(false)}
          severity={error} // Adjust the severity as needed
        />
        <div className="container-fluid px-5 mt-3">
          {renderAccordion([
            {
              title: "Team Details",
              content: (
                <div className="container-fluid px-0">
                  <div className="row mb-3">
                    <div className="col-md-3">
                      <TextInput
                        label="Team Name"
                        name="name"
                        required={true}
                        value={teamName}
                        maxLength={50}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          let value = e.target.value;

                          // Prevent initial space
                          if (value.startsWith(" ")) return;

                          // Replace multiple spaces with a single space
                          value = value.replace(/\s{2,}/g, " ");

                          setTeamName(value);
                        }}
                        disabled={!isEditable}
                      />
                    </div>
                    <div className="col-md-3">
                      <FormattedPhoneInput
                        label="Team Phone"
                        name="phone"
                        value={phoneNumber}
                        onChange={setTeamPhone}
                        disabled={!isEditable}
                      />
                    </div>
                    <div className="col-md-3">
                      <FormattedPhoneInput
                        label="Team Fax"
                        name="fax"
                        value={faxNumber}
                        onChange={setTeamFax}
                        disabled={!isEditable}
                      />
                    </div>
                    <div className="col-md-3">
                      <TextInput
                        label="Team Email ID"
                        name="email"
                        value={emailAddress}
                        maxLength={100}
                        onChange={(e) =>
                          setTeamEmail(e.target.value.replace(/\s/g, ""))
                        }
                        disabled={!isEditable}
                      />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-12">
                      <MultilineTextBox
                        label="Description"
                        name="description"
                        // required={true}
                        value={description}
                        maxLength={500}
                        onChange={(
                          e: React.ChangeEvent<HTMLTextAreaElement>,
                        ) => {
                          let value = e.target.value;

                          // Prevent initial space
                          if (value.startsWith(" ")) return;

                          // Replace multiple spaces with a single space
                          value = value?.trimStart();
                          value = value.replace(/ {2,}/g, " ");

                          setDescription(value);
                        }}
                        disabled={!isEditable}
                      />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-3 selection_dropdown adj_label_lt">
                      <SearchableSingleSelectDropdown
                        name="teamHodId"
                        label="Team Leader"
                        value={teamHodId}
                        onChange={(e, name, value) => setTeamHOD(value)}
                        options={hodOption} // Use the transformed options
                        required={true}
                        disabled={!isEditable}
                      />
                    </div>

                    <div className="col-md-3">
                      <div className="mt-3">
                        <label htmlFor="isActive" className="me-2 fw-bold">
                          Is Active
                        </label>
                        <input
                          type="checkbox"
                          id="isActive"
                          checked={isActive}
                          onChange={(e) => setIsActive(e.target.checked)}
                          className="form-check-input"
                          disabled={!isEditable}
                        />
                        {isActive && <span> Yes</span>}
                      </div>
                    </div>
                  </div>
                  <hr />

                  <div
                    className="mt-3 d-flex justify-content-end"
                    id="team-form-buttons"
                  >
                    <button
                      className="btn d-flex align-items-center btn-text me-3"
                      title="Cancel"
                      onClick={handleReset}
                      disabled={!hasChanges()}
                    >
                      <span className="material-icons mr-2">close</span>
                      Cancel
                    </button>
                    {isEditable ? (
                      <button
                        title="Save"
                        className="btn btn-primary ml-3 d-flex align-items-center"
                        onClick={handleSave}
                        disabled={!hasChanges()}
                      >
                        <span className="material-icons mx-1">save</span>Save
                      </button>
                    ) : null}
                  </div>
                </div>
              ),
            },
          ])}

          <Row className="my-3">
            {/* First table */}
            <Col className="col-6">
              {teammemberAccordion([
                {
                  title: "Team Members",
                  content: (
                    <>
                      <div
                        className="teams table-responsive"
                        style={{ maxHeight: "inherit", overflow: "inherit" }}
                      >
                        <table className="table table-bordered team_grid">
                          <thead className="thead-dark">
                            <tr>
                              <th style={{ width: "80%" }}>Employee</th>
                              <th
                                align="center"
                                className="text-center"
                                style={{ width: "20%" }}
                              >
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {/* Dropdown Row for first table */}
                            <tr>
                              <td style={{ width: "80%" }}>
                                <TeamMultipleDropdown
                                  label="Select Employees"
                                  options={employeeOption} // Pass transformed data here
                                  values={selectedEmployee} // Selected values
                                  onChange={setSelectedEmployee} // Update selected values
                                  style={{ width: "100%" }}
                                  disabled={
                                    (!teamId && !userData?.teamId) ||
                                    !isEditable
                                  } // Disable if no ID is available
                                />
                              </td>
                              <td
                                className="text-center"
                                style={{ width: "20%" }}
                              >
                                <td
                                  className="text-center"
                                  style={{
                                    display: "flex", // Aligns the buttons horizontally
                                    justifyContent: "center", // Centers the buttons horizontally in the cell
                                    gap: "5px", // Adds space between the buttons
                                    height: "auto", // Maintains the cell height
                                  }}
                                >
                                  <button
                                    className="btn btn-outline-primary d-flex align-items-center justify-content-center"
                                    onClick={handleAdd}
                                    disabled={selectedEmployee.length === 0}
                                  >
                                    <span className="material-symbols-outlined me-1">
                                      add_circle
                                    </span>
                                    Add
                                  </button>

                                  {/* Cancel button */}
                                </td>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div
                        className="teams table-responsive"
                        style={{ maxHeight: "inherit" }}
                      >
                        <table className="table table-bordered team_grid">
                          <tbody>
                            {/* Added Rows for first table */}
                            {addedEmployee.map((option, index) => {
                              // Find the group that contains the selected option
                              const doctorGroup = employeeOption.find((group) =>
                                group.options.some(
                                  (item) => item.value === option,
                                ),
                              );

                              // If doctorGroup is found, get the doctor name and group information
                              const doctorName = doctorGroup?.options.find(
                                (item) => item.value === option,
                              )?.label;
                              const groupName = doctorGroup?.group || "";

                              // Get the first letter of the group name
                              const groupNameInitial = groupName.charAt(0);
                              // Determine the background color for the group (fallback to grey if no color is found)
                              const groupColor =
                                dynamicGroupColors[groupName] || "#ccc";

                              return (
                                <tr key={index}>
                                  <td style={{ width: "80%" }}>
                                    {groupNameInitial && doctorName ? (
                                      <>
                                        <span
                                          className="circleTeam"
                                          title={groupName} // Tooltip for the group name
                                          style={{
                                            backgroundColor: groupColor, // Use the color mapped to the group
                                          }}
                                        >
                                          {groupNameInitial}
                                        </span>
                                        {doctorName}
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </td>
                                  <td
                                    className="text-center"
                                    style={{ width: "20%" }}
                                  >
                                    <span
                                      onClick={() =>
                                        option !== teamHodId &&
                                        handleRemove(option)
                                      }
                                      style={{
                                        color:
                                          option === teamHodId ? "#ccc" : "red",
                                        cursor:
                                          option === teamHodId
                                            ? "not-allowed"
                                            : "pointer",
                                        fontSize: "16px",
                                        pointerEvents:
                                          option === teamHodId
                                            ? "none"
                                            : "auto",
                                      }}
                                    >
                                      <span className="material-icons material-symbols-outlined">
                                        close
                                      </span>
                                    </span>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </>
                  ),
                },
              ])}
            </Col>

            {/* Second table */}
            <Col className="col-6">
              {associatedqmeAccordion([
                {
                  title: "Clients",
                  content: (
                    <>
                      <div
                        className="teams table-responsive"
                        style={{ maxHeight: "inherit", overflow: "inherit" }}
                      >
                        <table className="table table-bordered team_grid">
                          <thead className="thead-dark">
                            <tr>
                              <th style={{ width: "80%" }}>Clients</th>
                              <th
                                className="text-center"
                                style={{ width: "20%" }}
                              >
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {/* Dropdown Row for second table */}
                            <tr>
                              <td style={{ border: "none", width: "80%" }}>
                                <TeamMultipleDropdown
                                  label="Select Clients"
                                  options={stakeHolderOption}
                                  values={selectedStakeholders} // Pass selected values
                                  onChange={setSelectedStakeholders} // Update selected values
                                  style={{ width: "100%" }}
                                  disabled={
                                    (!teamId && !userData?.teamId) ||
                                    !isEditable
                                  }
                                />
                              </td>
                              <td
                                className="text-center"
                                style={{ width: "20%" }}
                              >
                                <td
                                  className="text-center"
                                  style={{
                                    display: "flex", // Aligns the buttons horizontally
                                    justifyContent: "center", // Centers the buttons horizontally in the cell
                                    gap: "5px", // Adds space between the buttons
                                    height: "auto", // Maintains the cell height
                                  }}
                                >
                                  <button
                                    className="btn btn-outline-primary d-flex align-items-center justify-content-center"
                                    onClick={handleAdd2}
                                    disabled={selectedStakeholders.length === 0}
                                  >
                                    <span className="material-symbols-outlined me-1">
                                      add_circle
                                    </span>
                                    Add
                                  </button>

                                  {/* Cancel button */}
                                </td>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div
                        className="teams table-responsive"
                        style={{ maxHeight: "inherit" }}
                      >
                        <table className="table table-bordered team_grid">
                          <tbody>
                            {stakeholderDetails.map((stakeholder, index) => {
                              const doctorId = stakeholder.stakeholderId;
                              const doctorName = stakeholder.entityName;
                              const stakeholderType =
                                stakeholder.stakeholderTypeDesc || "";
                              const groupNameInitial =
                                stakeholderType.charAt(0);
                              const groupColor =
                                dynamicGroupColors[stakeholderType] || "#ccc";

                              return (
                                <tr key={index}>
                                  <td style={{ width: "80%" }}>
                                    <span
                                      className="circleTeam"
                                      title={stakeholderType} // Tooltip shows full entityName
                                      style={{
                                        backgroundColor: groupColor,
                                      }}
                                    >
                                      {groupNameInitial}
                                    </span>
                                    {doctorName}
                                  </td>
                                  <td
                                    className="text-center"
                                    style={{ width: "20%" }}
                                  >
                                    <span
                                      onClick={() => handleRemove2(doctorId)}
                                      style={{
                                        color: "red",
                                        cursor: "pointer",
                                        fontSize: "16px",
                                      }}
                                    >
                                      <span className="material-icons material-symbols-outlined">
                                        close
                                      </span>
                                    </span>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </>
                  ),
                },
              ])}
            </Col>
          </Row>

          <Row className="my-3 pb-2">
            <Col>
              <button
                type="button"
                className="btn d-flex align-items-center btn-text-border"
                onClick={handleCancel}
              >
                <span className="material-icons mr-2">arrow_back</span>Back
              </button>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default AddUpdateTeam;
